// extracted by mini-css-extract-plugin
module.exports = {"hide":"fr0Br"};